import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Footer from './Footer';
import Modal from './Modal';

function Home() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [planId, setPlanId] = useState('');
  const navigate = useNavigate();

  const handleRunTest = () => {
    if (planId.trim()) {
      navigate(`/plan/${planId.trim()}`);
      setIsModalOpen(false);
      setPlanId('');
    }
  };

  return (
    <div className="container">
      {/* Hero Section */}
      <div style={{
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
        padding: '4rem 2rem',
        margin: '-20px -20px 3rem -20px',
        borderRadius: '0 0 24px 24px',
        textAlign: 'center',
        position: 'relative',
        overflow: 'hidden'
      }}>
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'url("data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="0.1"%3E%3Ccircle cx="30" cy="30" r="2"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")',
          opacity: 0.3
        }}></div>
        <div style={{ position: 'relative', zIndex: 1 }}>
          <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>✅</div>
          <h1 style={{ 
            fontSize: '3rem', 
            fontWeight: '700', 
            marginBottom: '1rem',
            textShadow: '0 2px 4px rgba(0,0,0,0.3)'
          }}>
            Test Plan Builder
          </h1>
          <p style={{ 
            fontSize: '1.3rem', 
            marginBottom: '2rem', 
            opacity: 0.9,
            maxWidth: '600px',
            margin: '0 auto 2rem auto'
          }}>
            Create, run, and share beautiful test plans with your team
          </p>
          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/builder" style={{
              background: 'rgba(255,255,255,0.2)',
              color: 'white',
              padding: '1rem 2rem',
              borderRadius: '12px',
              textDecoration: 'none',
              fontSize: '1.1rem',
              fontWeight: '600',
              border: '2px solid rgba(255,255,255,0.3)',
              backdropFilter: 'blur(10px)',
              transition: 'all 0.3s ease',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.5rem'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'rgba(255,255,255,0.3)';
              e.currentTarget.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'rgba(255,255,255,0.2)';
              e.currentTarget.style.transform = 'translateY(0)';
            }}>
              📝 Create Test Plan
            </Link>
            <button onClick={() => setIsModalOpen(true)} style={{
              background: 'transparent',
              color: 'white',
              padding: '1rem 2rem',
              borderRadius: '12px',
              fontSize: '1.1rem',
              fontWeight: '600',
              border: '2px solid rgba(255,255,255,0.5)',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.5rem'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'rgba(255,255,255,0.1)';
              e.currentTarget.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'transparent';
              e.currentTarget.style.transform = 'translateY(0)';
            }}>
              🧪 Run Existing Test
            </button>
          </div>
        </div>
      </div>

      {/* Quick Features */}
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', 
        gap: '2rem',
        marginBottom: '3rem'
      }}>
        <div className="home-feature-card" style={{
          background: window.matchMedia('(prefers-color-scheme: dark)').matches ? '#374151' : 'white',
          borderRadius: '16px',
          padding: '2rem',
          textAlign: 'center',
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
          border: `1px solid ${window.matchMedia('(prefers-color-scheme: dark)').matches ? '#4b5563' : '#e2e8f0'}`,
          transition: 'all 0.3s ease'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'translateY(-4px)';
          e.currentTarget.style.boxShadow = '0 8px 25px -5px rgba(0, 0, 0, 0.15)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)';
        }}>
          <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🎨</div>
          <h3 style={{ 
            marginBottom: '0.5rem', 
            color: window.matchMedia('(prefers-color-scheme: dark)').matches ? '#e5e7eb' : '#1e293b' 
          }}>Visual Builder</h3>
          <p style={{ 
            color: window.matchMedia('(prefers-color-scheme: dark)').matches ? '#9ca3af' : '#64748b', 
            margin: 0 
          }}>Create test plans with our intuitive visual editor</p>
        </div>

        <div className="home-feature-card" style={{
          background: window.matchMedia('(prefers-color-scheme: dark)').matches ? '#374151' : 'white',
          borderRadius: '16px',
          padding: '2rem',
          textAlign: 'center',
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
          border: `1px solid ${window.matchMedia('(prefers-color-scheme: dark)').matches ? '#4b5563' : '#e2e8f0'}`,
          transition: 'all 0.3s ease'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'translateY(-4px)';
          e.currentTarget.style.boxShadow = '0 8px 25px -5px rgba(0, 0, 0, 0.15)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)';
        }}>
          <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🤝</div>
          <h3 style={{ 
            marginBottom: '0.5rem', 
            color: window.matchMedia('(prefers-color-scheme: dark)').matches ? '#e5e7eb' : '#1e293b' 
          }}>Team Collaboration</h3>
          <p style={{ 
            color: window.matchMedia('(prefers-color-scheme: dark)').matches ? '#9ca3af' : '#64748b', 
            margin: 0 
          }}>Run tests together and share results instantly</p>
        </div>

        <div className="home-feature-card" style={{
          background: window.matchMedia('(prefers-color-scheme: dark)').matches ? '#374151' : 'white',
          borderRadius: '16px',
          padding: '2rem',
          textAlign: 'center',
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
          border: `1px solid ${window.matchMedia('(prefers-color-scheme: dark)').matches ? '#4b5563' : '#e2e8f0'}`,
          transition: 'all 0.3s ease'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'translateY(-4px)';
          e.currentTarget.style.boxShadow = '0 8px 25px -5px rgba(0, 0, 0, 0.15)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)';
        }}>
          <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>📊</div>
          <h3 style={{ 
            marginBottom: '0.5rem', 
            color: window.matchMedia('(prefers-color-scheme: dark)').matches ? '#e5e7eb' : '#1e293b' 
          }}>Smart Reports</h3>
          <p style={{ 
            color: window.matchMedia('(prefers-color-scheme: dark)').matches ? '#9ca3af' : '#64748b', 
            margin: 0 
          }}>Export beautiful reports for GitHub and teams</p>
        </div>
      </div>

      <Modal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)}
        title="🧪 Run Existing Test Plan"
      >
        <div className="form-group">
          <label>Plan ID</label>
          <input
            type="text"
            className="form-control"
            value={planId}
            onChange={(e) => setPlanId(e.target.value)}
            placeholder="e.g., green-laptop-snake"
            onKeyPress={(e) => e.key === 'Enter' && handleRunTest()}
          />
        </div>
        <div className="modal-buttons">
          <button className="btn btn-primary" onClick={handleRunTest}>
            🚀 Open Test Plan
          </button>
          <button className="btn btn-secondary" onClick={() => setIsModalOpen(false)}>
            Cancel
          </button>
        </div>
      </Modal>

      <Footer />
    </div>
  );
}

export default Home; 